import styled from 'styled-components';
import device from '#app/interface/devices';

export const LinkBlock = styled.span`
  width: 270px;
  height: 48px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding-left: 20px;
  padding-right: 20px;
  box-sizing: border-box;
  border-radius: 10px 0 0 10px;
  overflow: hidden;
  cursor: pointer;
  background: #000;
  position: relative;

  :after {
    filter: grayscale(100%) brightness(200%);
    width: 22px;
    height: 15px;
    position: absolute;
    display: block;
    content: '';
    left: 170px;
    transition: 0.3s all;
    top: 55%;
    transform: translate3d(0, -50%, 0);
  }

  @media ${device.mobileL} {
    display: none;
  }
`;

export const CommentBlock = styled.span`
  position: absolute;
  left: 20px;
  top: 52px;
  font-size: 12px;
  line-height: 16px;
  display: block;
  color: #929292;
  transition: 0.3s opacity;
`;
